import { Component, HostBinding, Input, Output } from "@angular/core";
import { Subject } from "rxjs";
import { TabContext } from "../tab-context";

@Component({
    selector: 'tyt-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss']
})
export class TabComponent {
    constructor(
        private tabContext : TabContext
    ) {
        this.id = `tab${this.tabContext.nextTabId++}`;
    }

    @Input()
    id : string;

    @Input()
    label : string;

    @Input()
    visible = true;

    @HostBinding('class.selected')
    selected = false;

    @HostBinding('attr.role')
    role = 'tabpanel';

    @Output()
    selectedChange = new Subject<boolean>();

    @Output('selected')
    wasSelected = new Subject<void>();

    @Output('unselected')
    wasUnselected = new Subject<void>();

    @HostBinding('attr.aria-labelledby')
    get labelledBy() {
        return `tabbutton_${this.id}`;
    }
    
    unselect() {
        this.selected = false;
        this.selectedChange.next(this.selected);
        this.wasUnselected.next();
    }

    select() {
        this.selected = true;
        this.selectedChange.next(this.selected);
        this.wasSelected.next();
    }
}